import axios from '@/server/axios'


export function queryArticleList(menuId,plateId,pageIndex,pageSize) {
  return axios({
    url: 'officialWebsite/articleList.do',
    method: 'get',
    params: {
      menuId,
      plateId,
      pageIndex,
      pageSize
    }
  })
}

//搜索文章列表
export function searchArticleList(menuId,title,pageIndex,pageSize) {
  return axios({
    url: 'officialWebsite/searchByMenuId.do',
    method: 'get',
    params: {
      menuId,
      title,
      pageIndex,
      pageSize
    }
  })
}
